import {noop} from 'lodash';
import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {
  ClickEventHandler,
  FrontClickEvent,
} from '../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {DataEventActionsEnum} from '../../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {OnboardingDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {useDataEventTracking} from '../../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {InfoBubblePillVariantsEnum} from '../../../common/infoBubbles/infoBubblePill';
import {EducationTip} from '../../../educationTips/educationTip';
import {generateStepText} from '../../welcome/onboardingWelcomeHelpers';
import {SandboxEducationTipProps} from './sandboxEducationTip';

/*
 * Component.
 */

const endDemoActionLabel = <Trans id="infobubble-onboarding-end-demo">End demo</Trans>;
const nextDemoActionLabel = (
  <Trans id="infobubble-onboarding-next-demo-analytics">Next demo: Analytics</Trans>
);

export const RulesSlaTimerEducationTip: FC<SandboxEducationTipProps> = (props) => {
  const {trackDataEvent} = useDataEventTracking();

  const onNextDemoClick = async (event: FrontClickEvent) => {
    trackDataEvent(DataEventActionsEnum.CLICK, OnboardingDataEventObject.DEMO_RULES_SLA_TIMER_NEXT, {});
    // Wait for the analytics demo to be provisioned before archiving the rules demo conversation.
    await props.onNextClick(event);
  };

  const nextDemoAction = {
    label: nextDemoActionLabel,
    onClick: onNextDemoClick,
  };

  const onEndDemoClick: ClickEventHandler = (event) => {
    trackDataEvent(DataEventActionsEnum.CLICK, OnboardingDataEventObject.DEMO_RULES_SLA_TIMER_END, {});
    // Advance/finish the rules demo, despite not moving on to the analytics demo.
    props.onEndClick(event, {shouldAdvanceStep: true});
  };

  const endDemoAction = {
    label: endDemoActionLabel,
    onClick: onEndDemoClick,
  };

  return (
    <EducationTip
      anchor={props.anchor}
      position="top"
      isVisible={props.isVisible}
      isStandalone
      onRequestClose={noop}
      pillType={InfoBubblePillVariantsEnum.EDUCATION}
      title={<Trans id="infobubble-onboarding-sla-timer-title">Ensure response time goals are met</Trans>}
      stepCounter={generateStepText(4, 4)}
      onPrimaryClick={nextDemoAction.onClick}
      primaryActionLabel={nextDemoAction.label}
      secondaryAction={endDemoAction}
      dataObjectName={OnboardingDataEventObject.DEMO_RULES_SLA_TIMER}
    >
      <Trans id="infobubble-onboarding-sla-timer-description">
        A timer is automatically applied because your team has a response time goal for VIPs. If the time runs
        out, your team will be alerted.
        <br />
        Rules like these help you streamline processes, for higher efficiency and happier customers.
      </Trans>
    </EducationTip>
  );
};
